import React from 'react';
import './AboutPage.css';
import familyBackground from '../../assets/family-background.png';

export const AboutPage: React.FC = () => {
  return (
    <div className="about-page">
      {/* Imagem de fundo */}
      <div 
        className="background-image"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `url(${familyBackground})`,
          backgroundSize: '100% auto',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
          zIndex: 1
        }}
      />
      
      {/* Overlay claro para melhor contraste */}
      <div 
        className="background-overlay"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.35))',
          zIndex: 2
        }}
      />

      <div className="about-container">
        <div className="about-header">
          <h1>Sobre a Sand Imóveis</h1>
          <div className="about-divider"></div>
        </div>

        <div className="about-content">
          <div className="about-text">
            <p>
              Sand Imóveis nasceu para transformar a forma como você encontra e vive seu imóvel em Balneário Camboriú. 
              Somos especialistas em locação de imóveis de alto padrão, com foco em oferecer não apenas casas e 
              apartamentos, mas experiências completas de moradia.
            </p>
            
            <p>
              Nosso diferencial está no atendimento consultivo e personalizado: entendemos as suas necessidades, 
              acompanhamos cada detalhe do processo e oferecemos suporte mesmo após a assinatura do contrato. 
              Da manutenção à gestão do imóvel, garantimos tranquilidade, segurança e praticidade para 
              proprietários e inquilinos.
            </p>
            
            <p>
              Combinando tecnologia, equipe especializada e a essência do lifestyle de Balneário Camboriú, 
              a Sand Imóveis conecta pessoas a lares que representam mais do que um endereço, 
              representam o seu estilo de vida.
            </p>
          </div>

          <div className="about-features">
            <div className="feature-card">
              <div className="feature-icon">
                
              </div>
              <h3>Especialistas em Alto Padrão</h3>
              <p>Focamos em imóveis de qualidade superior em Balneário Camboriú</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon"></div>
              <h3>Atendimento Personalizado</h3>
              <p>Consultoria completa e acompanhamento em todo o processo</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon"></div>
              <h3>Lifestyle Balneário</h3>
              <p>Conectamos você ao estilo de vida único da região</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
